export default __webpack_public_path__ + "static/media/INTP.3f56ea17.svg";